export default {
  SPOOL: 'SPOOL',
  BATCH: 'BATCH'
};
